// general
export const PROCEED_TO_NEXT_FORM_STEP = "PROCEED_TO_NEXT_FORM_STEP";
export const GO_FORM_STEP_BACK = "GO_FORM_STEP_BACK";
export const SET_FORM_LOADING = "SET_FORM_LOADING";
export const RESET_FORM_LOADING = "RESET_FORM_LOADING";
export const SUBMIT_FORM_ERROR = "SUBMIT_FORM_ERROR";
export const EMAIL_ALREADY_TAKEN_ERROR = "EMAIL_ALREADY_TAKEN_ERROR";
export const SELECT_TAB = "SELECT_TAB";
export const SHOW_REVIEW_PAGE = "SHOW_REVIEW_PAGE";

// subscription plans
export const LOAD_SUBSCRIPTION_PLANS = "LOAD_SUBSCRIPTION_PLANS";
export const TOGGLE_TERMS_MODAL = "TOGGLE_TERMS_MODAL";
export const LOAD_TERMS_DATA = "LOAD_TERMS_DATA";
export const FETCH_TERMS_OF_BUSINESS = "FETCH_TERMS_OF_BUSINESS";
export const TOGGLE_PAY_TERMS = "TOGGLE_PAY_TERMS";
export const LOAD_ANNUAL_SUBSCRIPTION_PLANS = "LOAD_ANNUAL_SUBSCRIPTION_PLANS";
export const LOAD_ANNUAL_SUBSCRIPTION_PLANS_ERROR =
  "LOAD_ANNUAL_SUBSCRIPTION_PLANS_ERROR";
export const LOADING_SUBSCRIPTION_PLANS = "LOADING_SUBSCRIPTION_PLANS";

// errors
export const LOAD_SUBSCRIPTION_PLANS_ERROR = "LOAD_SUBSCRIPTION_PLANS_ERROR";
export const FETCH_TERMS_OF_BUSINESS_ERROR = "FETCH_TERMS_OF_BUSINESS_ERROR";

// dashboard
export const LOAD_AGENCY_METRICS = "LOAD_AGENCY_METRICS";
export const LOAD_AGENCY_METRICS_ERROR = "LOAD_AGENCY_METRICS_ERROR";
export const LOAD_EMPLOYER_METRICS = "LOAD_EMPLOYER_METRICS";
export const LOAD_EMPLOYER_METRICS_ERROR = "LOAD_EMPLOYER_METRICS_ERROR";
export const SUBMIT_REVIEW_ERROR = "SUBMIT_REVIEW_ERROR";
export const TOGGLE_FINISH_JOB_POST_MODAL = "TOGGLE_FINISH_JOB_POST_MODAL";

// agency profile
export const LOAD_AGENCY_PROFILE = "LOAD_AGENCY_PROFILE";
export const LOAD_AGENCY_PROFILE_ERROR = "LOAD_AGENCY_PROFILE_ERROR";
export const LOAD_RECRUITER_REVIEWS = "LOAD_RECRUITER_REVIEWS";
export const LOAD_APPLICANT_REVIEWS = "LOAD_APPLICANT_REVIEWS";
export const LOAD_TEAM_MEMBERS = "LOAD_TEAM_MEMBERS";
export const SUBMIT_UPDATE = "SUBMIT_UPDATE";
export const SUBMIT_UPDATE_ERROR = "SUBMIT_UPDATE_ERROR";
export const SET_SPECIALITIES_FORM_LOADING = "SET_SPECIALITIES_FORM_LOADING";
export const SET_QUALIFICATIONS_FORM_LOADING =
  "SET_QUALIFICATIONS_FORM_LOADING";
export const SET_ABOUT_ME_FORM_LOADING = "SET_ABOUT_ME_FORM_LOADING";
export const SET_USER_FORM_LOADING = "SET_USER_FORM_LOADING";
export const SET_ABOUT_COMPANY_FORM_LOADING = "SET_ABOUT_COMPANY_FORM_LOADING";
export const SET_IMAGES_FORM_LOADING = "SET_IMAGES_FORM_LOADING";
export const SET_REVIEWS_LOADING = "SET_REVIEWS_LOADING";
export const UPDATE_AVATAR = "UPDATE_AVATAR";
export const UPDATE_AVATAR_ERROR = "UPDATE_AVATAR_ERROR";
export const UPDATE_PROFILE_IMAGE = "UPDATE_PROFILE_IMAGE";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
export const REJECT_ENGAGEMENT = "REJECT_ENGAGEMENT";
export const REJECT_ENGAGEMENT_ERROR = "REJECT_ENGAGEMENT_ERROR";
export const ACCEPT_ENGAGEMENT_ERROR = "ACCEPT_ENGAGEMENT_ERROR";
export const ACCEPT_ENGAGEMENT = "ACCEPT_ENGAGEMENT";
export const SET_REJECT_ENGAGEMENT_LOADING = "SET_REJECT_ENGAGEMENT_LOADING";
export const SET_ACCEPT_ENGAGEMENT_LOADING = "SET_ACCEPT_ENGAGEMENT_LOADING";

// candidate record page
export const LOAD_CANDIDATE_RECORD = "LOAD_CANDIDATE_RECORD";
export const LOAD_CANDIDATE_RECORD_ERROR = "LOAD_CANDIDATE_RECORD_ERROR";

// flash message
export const SHOW_FLASH_MESSAGE = "SHOW_FLASH_MESSAGE";
export const HIDE_FLASH_MESSAGE = "HIDE_FLASH_MESSAGE";

// employer analytics
export const LOAD_EMPLOYER_ANALYTICS = "LOAD_EMPLOYER_ANALYTICS";
export const LOAD_AGENCY_PERFORMANCE = "LOAD_AGENCY_PERFORMANCE";
export const LOAD_JOB_PERFORMANCE = "LOAD_JOB_PERFORMANCE";
export const LOAD_JOB_PERFORMANCE_ERROR = "LOAD_JOB_PERFORMANCE_ERROR";
export const LOAD_PSL_PERFORMANCE = "LOAD_PSL_PERFORMANCE";
export const LOAD_PSL_PERFORMANCE_ERROR = "LOAD_PSL_PERFORMANCE_ERROR";
export const EMPLOYER_ANALYTICS_FILTER = "EMPLOYER_ANALYTICS_FILTER";
export const RESET_PAGINATION_FLAG = "RESET_PAGINATION_FLAG";
export const RESET_DEFAULT_FILTERS = "RESET_DEFAULT_FILTERS";

export const LOAD_EMPLOYER_ANALYTICS_ERROR = "LOAD_EMPLOYER_ANALYTICS_ERROR";
export const LOAD_AGENCY_PERFORMANCE_ERROR = "LOAD_AGENCY_PERFORMANCE_ERROR";
// employer analytics individual widgets
export const LOAD_EMPLOYER_PIPELINE_WIDGET = "LOAD_EMPLOYER_PIPELINE_WIDGET";
export const LOAD_EMPLOYER_PIPELINE_WIDGET_ERROR =
  "LOAD_EMPLOYER_PIPELINE_WIDGET_ERROR";
export const LOAD_EMPLOYER_TIME_TO_HIRE_WIDGET =
  "LOAD_EMPLOYER_TIME_TO_HIRE_WIDGET";
export const LOAD_EMPLOYER_TIME_TO_HIRE_WIDGET_ERROR =
  "LOAD_EMPLOYER_TIME_TO_HIRE_WIDGET_ERROR";
export const LOAD_EMPLOYER_OFFER_TO_PLACEMENT_WIDGET =
  "LOAD_EMPLOYER_OFFER_TO_PLACEMENT_WIDGET";
export const LOAD_EMPLOYER_OFFER_TO_PLACEMENT_WIDGET_ERROR =
  "LOAD_EMPLOYER_OFFER_TO_PLACEMENT_WIDGET_ERROR";
export const LOAD_EMPLOYER_SPEND_PER_SECTOR_WIDGET =
  "LOAD_EMPLOYER_SPEND_PER_SECTOR_WIDGET";
export const LOAD_EMPLOYER_SPEND_PER_SECTOR_WIDGET_ERROR =
  "LOAD_EMPLOYER_SPEND_PER_SECTOR_WIDGET_ERROR";
export const LOAD_EMPLOYER_TOTAL_JOBS_POSTED_WIDGET =
  "LOAD_EMPLOYER_TOTAL_JOBS_POSTED_WIDGET";
export const LOAD_EMPLOYER_TOTAL_JOBS_POSTED_WIDGET_ERROR =
  "LOAD_EMPLOYER_TOTAL_JOBS_POSTED_WIDGET_ERROR";
export const LOAD_EMPLOYER_TOTAL_JOBS_PER_SECTOR_WIDGET =
  "LOAD_EMPLOYER_TOTAL_JOBS_PER_SECTOR_WIDGET";
export const LOAD_EMPLOYER_TOTAL_JOBS_PER_SECTOR_WIDGET_ERROR =
  "LOAD_EMPLOYER_TOTAL_JOBS_PER_SECTOR_WIDGET_ERROR";
export const LOAD_EMPLOYER_TIME_TO_HIRE_TIMELINE_WIDGET =
  "LOAD_EMPLOYER_TIME_TO_HIRE_TIMELINE_WIDGET";
export const LOAD_EMPLOYER_TIME_TO_HIRE_TIMELINE_WIDGET_ERROR =
  "LOAD_EMPLOYER_TIME_TO_HIRE_TIMELINE_WIDGET_ERROR";
export const LOAD_EMPLOYER_APPLICATION_ACTIONS_TRACKING_WIDGET =
  "LOAD_EMPLOYER_APPLICATION_ACTIONS_TRACKING_WIDGET";
export const LOAD_EMPLOYER_APPLICATION_ACTIONS_TRACKING_WIDGET_ERROR =
  "LOAD_EMPLOYER_APPLICATION_ACTIONS_TRACKING_WIDGET_ERROR";
export const SET_CURRENTLY_SELECTED_COMPANY = "SET_CURRENTLY_SELECTED_COMPANY";

export const SELECT_COMPANY_FILTER = "SELECT_COMPANY_FILTER";
export const RESET_COMPANY_FILTER = "RESET_COMPANY_FILTER";
export const SELECT_DATE_RANGE_FILTER = "SELECT_DATE_RANGE_FILTER";
export const RESET_DATE_RANGE_FILTER = "RESET_DATE_RANGE_FILTER";
export const IS_DATE_PICKER_ACTIVE = "IS_DATE_PICKER_ACTIVE";
export const SET_PIPELINE_WIDGET_LOADING = "SET_PIPELINE_WIDGET_LOADING";
export const SET_TIME_TO_HIRE_WIDGET_LOADING =
  "SET_TIME_TO_HIRE_WIDGET_LOADING";
export const SET_SPEND_PER_SECTOR_WIDGET_LOADING =
  "SET_SPEND_PER_SECTOR_WIDGET_LOADING";
export const SET_JOBS_PER_SECTOR_WIDGET_LOADING =
  "SET_JOBS_PER_SECTOR_WIDGET_LOADING";
export const SET_TTH_TIMELINE_WIDGET_LOADING =
  "SET_TTH_TIMELINE_WIDGET_LOADING";
export const SET_OFFER_TO_PLACEMENT_WIDGET_LOADING =
  "SET_OFFER_TO_PLACEMENT_WIDGET_LOADING";
export const SET_TOTAL_JOBS_POSTED_WIDGET_LOADING =
  "SET_TOTAL_JOBS_POSTED_WIDGET_LOADING";
export const SET_AAT_WIDGET_LOADING = "SET_AAT_WIDGET_LOADING";
export const SET_PIPELINE_TIMESCALE = "SET_PIPELINE_TIMESCALE";
export const SET_SPEND_PER_SECTOR_TIMESCALE = "SET_SPEND_PER_SECTOR_TIMESCALE";
export const SET_JOBS_PER_SECTOR_TIMESCALE = "SET_JOBS_PER_SECTOR_TIMESCALE";
export const SET_TTH_TIMELINE_TIMESCALE = "SET_TTH_TIMELINE_TIMESCALE";
export const SET_AAT_TIMESCALE = "SET_AAT_TIMESCALE";
export const HANDLE_PDF_OPTIONS = "HANDLE_PDF_OPTIONS";
export const SELECT_ALL = "SELECT_ALL";
export const UNSELECT_ALL = "UNSELECT_ALL";

// how to guides
export const LOAD_HOW_TO_GUIDES = "LOAD_HOW_TO_GUIDES";
export const LOAD_HOW_TO_GUIDES_ERROR = "LOAD_HOW_TO_GUIDES_ERROR";

// PSL
export const LOAD_PSL = "LOAD_PSL";
export const LOAD_PSL_ERROR = "LOAD_PSL_ERROR";
export const TOGGLE_REMOVE_FROM_PSL_MODAL = "TOGGLE_REMOVE_FROM_PSL_MODAL";
export const SET_REMOVE_FROM_PSL_LOADING = "SET_REMOVE_FROM_PSL_LOADING";
export const SUBMIT_REMOVE_FROM_PSL = "SUBMIT_REMOVE_FROM_PSL";
export const SUBMIT_REMOVE_FROM_PSL_ERROR = "SUBMIT_REMOVE_FROM_PSL_ERROR";
export const CANCEL_REMOVE_FROM_PSL = "CANCEL_REMOVE_FROM_PSL";

// premium pricing
export const LOAD_PREMIUM_PRICING = "LOAD_PREMIUM_PRICING";
export const LOAD_PREMIUM_PRICING_ERROR = "LOAD_PREMIUM_PRICING_ERROR";

// applicant review form
export const SET_APPLICANT_REVIEW_FORM_LOADING =
  "SET_APPLICANT_REVIEW_FORM_LOADING";
export const RETRIEVE_APPLICANT_REVIEW = "RETRIEVE_APPLICANT_REVIEW";
export const RETRIEVE_APPLICANT_REVIEW_ERROR =
  "RETRIEVE_APPLICANT_REVIEW_ERROR";
export const UPDATE_APPLICANT_REVIEW = "UPDATE_APPLICANT_REVIEW";
export const UPDATE_APPLICANT_REVIEW_ERROR = "UPDATE_APPLICANT_REVIEW_ERROR";

// activity feed
export const LOAD_ACTIVITY_FEED = "LOAD_ACTIVITY_FEED";
export const LOAD_ACTIVITY_FEED_ERROR = "LOAD_ACTIVITY_FEED_ERROR";
export const LOAD_MORE_ACTIVITY_FEED_POSTS = "LOAD_MORE_ACTIVITY_FEED_POSTS";

// portal agency sign up page
export const SUBMIT_PORTAL_AGENCY_SIGN_UP_FORM =
  "SUBMIT_PORTAL_AGENCY_SIGN_UP_FORM";
export const SUBMIT_PORTAL_AGENCY_SIGN_UP_FORM_ERROR =
  "SUBMIT_PORTAL_AGENCY_SIGN_UP_FORM_ERROR";

// employer pending reviews
export const LOAD_EMPLOYER_PENDING_REVIEWS = "LOAD_EMPLOYER_PENDING_REVIEWS";
export const LOAD_EMPLOYER_PENDING_REVIEWS_ERROR =
  "LOAD_EMPLOYER_PENDING_REVIEWS_ERROR";
export const TOGGLE_REVIEW_MODAL = "TOGGLE_REVIEW_MODAL";
export const SHOW_PENDING_REVIEWS_PAGE = "SHOW_PENDING_REVIEWS_PAGE";
export const CLOSE_REVIEW_PAGE = "CLOSE_REVIEW_PAGE";
export const SUBMIT_REVIEW = "SUBMIT_REVIEW";
export const SHOW_FORM_THANK_YOU = "SHOW_FORM_THANK_YOU";
export const HIDE_FORM_THANK_YOU = "HIDE_FORM_THANK_YOU";
